import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useState, useEffect } from 'react';
import { UnifiedMapControls } from './components/MapControls';

const DEFAULT_POSITION = { lat: 32.08, lng: 34.78 };

// Beautiful numbered teardrop pin
const numberedIcon = (index) =>
  L.divIcon({
    className: 'mekomit-numbered-pin',
    html: `
      <div style="position:relative;width:34px;height:44px;transform:translate(-50%,-100%);">
        <svg width="34" height="44" viewBox="0 0 34 44" fill="none" xmlns="http://www.w3.org/2000/svg"
             style="filter:drop-shadow(0 3px 5px rgba(0,0,0,.35));">
          <path d="M17 0C7.6 0 0 7.6 0 17c0 12 17 27 17 27s17-15 17-27C34 7.6 26.4 0 17 0z" fill="#ff6b35"/>
          <circle cx="17" cy="17" r="12" fill="#fff"/>
        </svg>
        <span style="position:absolute;top:5px;left:0;width:34px;text-align:center;
                     font:700 14px/24px system-ui,sans-serif;color:#ff6b35;">${index + 1}</span>
      </div>`,
    iconSize: [34, 44],
    iconAnchor: [17, 44],
  });

/**
 * Multi-point location picker.
 * `points` is an array of { lat, lng }. Clicking the map appends a point.
 */
export const MultiLocationPicker = ({ points, onAddPoint, center }) => {
  const [mapCenter, setMapCenter] = useState(null);

  useEffect(() => {
    if (center && center.lat && center.lng) {
      setMapCenter(center);
    } else if (points && points.length > 0) {
      setMapCenter(points[0]);
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          setMapCenter({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        () => setMapCenter(DEFAULT_POSITION)
      );
    } else {
      setMapCenter(DEFAULT_POSITION);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ClickHandler = () => {
    useMapEvents({
      click(e) {
        onAddPoint({ lat: e.latlng.lat, lng: e.latlng.lng });
      },
    });
    return null;
  };

  if (!mapCenter) return null;

  return (
    <MapContainer
      center={[mapCenter.lat, mapCenter.lng]}
      zoom={13}
      scrollWheelZoom={true}
      style={{ height: '100%', width: '100%', borderRadius: '12px' }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <ClickHandler />
      {points.map((p, i) => (
        <Marker key={`${p.lat},${p.lng},${i}`} position={[p.lat, p.lng]} icon={numberedIcon(i)} />
      ))}
      <UnifiedMapControls userLocation={[mapCenter.lat, mapCenter.lng]} showLayerSwitcher={true} />
    </MapContainer>
  );
};
